// Chuyển trang bằng View Transitions API: trang cũ mờ đi trong lúc trang mới hiện lên (cross-fade), thay vì trang cũ
// biến mất ngay rồi trang mới mới hiện dần. Hiệu ứng nằm ở App.css (::view-transition-*).
//
// Router dùng history tự tạo (unstable_HistoryRouter) để mọi lần đổi trang đều đi qua đây: Link, navigate(),
// Navigate và nút Back/Forward. Trình duyệt chưa hỗ trợ hoặc máy bật giảm chuyển động thì giữ hiệu ứng CSS của
// FastPageTransition.
import { createBrowserHistory } from '@remix-run/router';

// Trang mới chưa tải xong chunk thì chờ tối đa chừng này rồi cho hiệu ứng chạy (màn hình đứng ở trang cũ trong lúc chờ,
// không nhận chạm). Chunk các tab đã tải trước (utils/tabPages.js) nên thường commit ngay; giữ ngắn để mạng chậm
// không đứng hình lâu, quá hạn thì trang cũ vẫn hiện và tương tác được tới khi trang mới tải xong
const COMMIT_TIMEOUT_MS = 350;

let pendingCommit = null;
let running = false;

// Trang đang được đưa vào bằng View Transitions: trang mới không chạy thêm hiệu ứng CSS của nó
// (FastPageTransition/PageTransition đọc một lần lúc mount)
export const isViewTransitionRunning = () => running;

const canUseViewTransition = () => (
  typeof document !== 'undefined'
  && typeof document.startViewTransition === 'function'
  && !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)
);

// Gọi trong useLayoutEffect khi route mới đã commit (App.js RouteCommitSignal)
export const notifyRouteCommitted = () => {
  if (pendingCommit) pendingCommit();
};

const waitForCommit = () => new Promise((resolve) => {
  if (pendingCommit) pendingCommit();
  const done = () => {
    clearTimeout(timer);
    if (pendingCommit === done) pendingCommit = null;
    resolve();
  };
  const timer = setTimeout(done, COMMIT_TIMEOUT_MS);
  pendingCommit = done;
});

export const createTransitionHistory = () => {
  const history = createBrowserHistory({ v5Compat: true });
  const listen = history.listen.bind(history);
  let currentPath = history.location.pathname;

  history.listen = (listener) => listen((update) => {
    // Đổi hash/query trong cùng trang (vd. /payments#withdrawal-history) thì không chạy hiệu ứng
    const samePage = update.location.pathname === currentPath;
    currentPath = update.location.pathname;
    if (samePage || !canUseViewTransition()) {
      listener(update);
      return;
    }

    // vt-nav: đặt tên riêng cho TopBar/BottomNav trong lúc chuyển
    const root = document.documentElement;
    root.classList.add('vt-nav');
    running = true;
    const transition = document.startViewTransition(() => {
      listener(update);
      return waitForCommit();
    });
    transition.finished.finally(() => {
      running = false;
      root.classList.remove('vt-nav');
    });
  });

  return history;
};
